import type { GeoPoint } from '@aeris/contracts'
import { decodePolyline } from '@aeris/maps'

/**
 * Como a tela de Rotas de entrega fala de tempo, de dinheiro e de cor (F266).
 */

/** Uma cor por entregador, legível no claro e no escuro. */
export const ROUTE_COLORS = [
  '#2563eb',
  '#dc2626',
  '#16a34a',
  '#9333ea',
  '#ea580c',
  '#0891b2',
  '#be185d',
  '#4d7c0f',
] as const

export const routeColor = (index: number): string =>
  ROUTE_COLORS[index % ROUTE_COLORS.length] ?? '#2563eb'

/** 1.250 s → "21 min"; 4.000 s → "1 h 07". */
export const durationText = (seconds: number): string => {
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} min`
  return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, '0')}`
}

/** A hora em Brasília daqui a `seconds` contando de `from`. */
export const clockAfter = (from: Date, seconds: number): string =>
  new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(from.getTime() + seconds * 1000))

export const kmText = (meters: number): string =>
  meters < 1000
    ? `${meters} m`
    : `${(meters / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} km`

/** "25.000000" → "R$ 25,00". */
export const moneyText = (amount: string): string =>
  Number(amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

/** Os pedaços do caminho, um por linha (ver o servidor), em pontos. */
export const pathPoints = (encoded: string | null): GeoPoint[][] =>
  encoded === null || encoded === ''
    ? []
    : encoded
        .split('\n')
        .filter((piece) => piece !== '')
        .map((piece) => decodePolyline(piece))
